import { FilterProp } from 'frontend/types'
import FilterDropdown from './FilterDropdown/FilterDropdown'
import { InterpretationLabel, ToggleParams } from 'frontend/enums'
import { filterInterpretationsClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { SearchParams } from 'backend/services/types/urApiService.types'

type Props = {
  signLangAudioDesc: FilterProp[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const SignLanguageAndAudioDescription = ({
  signLangAudioDesc,
  searchParams,
  updateSearch,
}: Props) => {
  const {
    is_audio_described: isAudioDescribed,
    is_sign_language_interpreted: isSignLanguageInterpreted,
  } = searchParams

  const activeLabels: string[] = []

  if (isAudioDescribed) {
    activeLabels.push(InterpretationLabel.AUDIO_DESCRIBED)
  }
  if (isSignLanguageInterpreted) {
    activeLabels.push(InterpretationLabel.SIGN_LANGUAGE_INTERPRETED)
  }

  const handleOptionSelect = (option: FilterProp) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterInterpretationsClick(option.label)

    const newValue =
      option.value === ToggleParams.IS_AUDIO_DESCRIBED
        ? !isAudioDescribed
        : !isSignLanguageInterpreted

    updateSearch({
      [option.value]: newValue === true ? newValue : null,
    })
  }

  return (
    <FilterDropdown
      activeLabels={activeLabels}
      label="Syn- och teckenspråkstolkat"
      onOptionSelect={handleOptionSelect}
      options={signLangAudioDesc}
    />
  )
}

export default SignLanguageAndAudioDescription
